<template>
  <div id="app">
    <BlogHeader v-if="!isAdminPage" />
    <AdminSidebar v-if="isAdminPage" />
    <div :class="isAdminPage ? 'admin-main' : 'blog-main'">
      <router-view />
    </div>
    <BlogFooter v-if="!isAdminPage" />
    <BackToTop v-if="!isAdminPage" />
  </div>
</template>

<script>
import BlogHeader from './components/BlogHeader.vue'
import BlogFooter from './components/BlogFooter.vue'
import AdminSidebar from './components/AdminSidebar.vue'
import BackToTop from './components/BackToTop.vue'

export default {
  name: 'App',
  components: { BlogHeader, BlogFooter, AdminSidebar, BackToTop },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  created() {
    this.$store.dispatch('initTheme')
    this.loadCommonData()
  },
  methods: {
    async loadCommonData() {
      try {
        const { frontApi } = require('./utils/api')
        const [catRes, tagRes] = await Promise.all([
          frontApi.getCategories(),
          frontApi.getTags()
        ])
        this.$store.dispatch('loadCategories', catRes.categories || [])
        this.$store.dispatch('loadTags', tagRes.tags || [])
      } catch (e) {
        // 首次加载失败不影响页面
      }
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  position: relative;
  z-index: 1;
}
.blog-main {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px 16px;
  padding-top: 70px;
  min-height: calc(100vh - 140px);
}
.admin-main {
  margin-left: 220px;
  padding: 20px;
  min-height: 100vh;
  background: #f5f7fa;
}
@media (max-width: 768px) {
  .blog-main {
    padding: 10px 12px;
    padding-top: 60px;
  }
  .admin-main {
    margin-left: 0;
    padding: 10px;
  }
}
</style>
